import classNames from 'classnames';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import React from 'react';
import './index.scss';

export interface EcoBarPromoProps {
    /**
     * 跳转链接
     */
    href?: string;
    /**
     * 左侧小图标
     */
    logo?: string;
    /**
     * 右侧文案
     */
    title?: string;
    /**
     * 背景色
     */
    bgColor?: string;
    /**
     * 文案字体色
     */
    titleColor?: string;
    /**
     * 自定义类名
     */
    className?: string;
}

/**
 * bar条-促销
 */
const EcoBarPromo: React.FC<EcoBarPromoProps> = ({ href, logo, title, bgColor, titleColor, className }) => {
    const prefixCls = `eco-bar-promo`;
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const compStyle = {
        '--bar-promo-bg': bgColor,
        '--bar-promo-title-color': titleColor,
    } as React.CSSProperties;
    return (
        <EcoLink href={href} className={compCls} style={compStyle}>
            <div className={`${prefixCls}-content`}>
                {logo && <EcoImg pc={logo} className={`${prefixCls}-logo`} />}
                <div className={`${prefixCls}-title`}>{title}</div>
            </div>
        </EcoLink>
    );
};

export default EcoBarPromo;
